import exameRepository from './exameRepository'
import laboratorioRepository from './laboratorioRepository'

export default baseUrl => {
    return {
        exame: exameRepository(baseUrl),
        laboratorio: laboratorioRepository(baseUrl),
    }
}
